<template>
  <div>
    <group-card title="ADP Breakdown" icon="bubble_chart" padded>
      <md-dialog-content>
        <div class="md-layout input-layout">
          <div class="md-layout-item input-layout md-small-size-25 md-size-25">
            <validated-number-input
              class="md-layout-item md-small-size-100 md-size-100"
              label="Application ID"
              v-model="application_id"
              errormsg="Application ID must be numbers."
            >
            </validated-number-input>
          </div>
          <md-dialog-actions class="show-list-button">
            <loading-icon-text-button
              @click="getAssessmentOutcomesList"
              icon="search"
              :loading="loading"
            >
              Run
            </loading-icon-text-button>
          </md-dialog-actions>
        </div>

        <div
          v-if="
            assessmentOutcomes.ba_breakdown &&
            assessmentOutcomes.ba_breakdown.length > 0
          "
        >
          <md-table v-model="assessmentOutcomes.ba_breakdown">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="ADP Status">{{ item.ba_status }}</md-table-cell>
              <md-table-cell md-label="Type">{{ item.type }}</md-table-cell>
              <md-table-cell md-label="Created Time">{{ item.created_time }}</md-table-cell>
              <md-table-cell md-label="Action">
                <loading-icon-text-button
                  class="md-primary md-sm"
                  icon="description"
                  @click="getAdpBreakdownDetail($event, item)"
                  :value="item.actions"
                  :loading="loading"
                >
                  {{ item.isSelected ? "Hide" : "Show" }}
                </loading-icon-text-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </md-dialog-content>
    </group-card>

    <group-card title="Assessment Detail" icon="bubble_chart" padded>
      <md-dialog-content>
        <div v-if="applicationData">
          <div class="md-layout">
            <div class="md-layout-item">
              <group-card-row title="Application Detail">
                <template v-slot:content>
                  <div class="md-layout-item md-size-100">
                    <div class="property-list">
                      <property-view name="Application ID">
                        {{ assessmentOutcomes.application_id }}
                      </property-view>
                      <br />
                      <property-view name="Application Status">
                        {{ assessmentOutcomes.status }}
                      </property-view>
                      <br />
                      <property-view name="Broker">
                        {{ assessmentOutcomes.broker | name }}
                      </property-view>
                      <br />
                      <property-view name="Type">
                        {{ applicationData.type }}
                      </property-view>
                      <br />
                      <property-view name="ADP Status">
                        {{ applicationData.ba_status }}
                      </property-view>
                      <br />
                      <property-view name="Created Time">
                        {{ applicationData.created_time }}
                      </property-view>
                    </div>
                  </div>
                </template>
              </group-card-row>

              <group-card-row title="Assessment Reasons">
                <template v-slot:content>
                  <div class="md-layout-item">
                    <div class="property-list bottom-div">
                      <property-view
                        v-for="reason in applicationData.reasons"
                        :key="reason.code"
                        :name="reason.code"
                      >
                        {{ reason.description }}
                      </property-view>
                    </div>
                  </div>
                </template>
              </group-card-row>

              <group-card-row title="Approved Lenders">
                <template v-slot:content>
                  <div class="md-layout-item">
                    <div class="property-list bottom-div">
                      <property-view
                        v-for="option in applicationData.options"
                        :name="option.lender_name"
                        :key="option.id"
                      >
                        {{ option.product_name }}
                      </property-view>
                    </div>
                  </div>
                </template>
              </group-card-row>
            </div>
          </div>

          <div class="padded">
            <div v-for="(value, key) in applicationData.products_ko" :key="key">
              <table class="data-table md-layout-item product-breakdown">
                <thead>
                  <tr>
                    <th>Lender</th>
                    <th>Product</th>
                    <th>Knockouts</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ko, index) in value" :key="index">
                    <td>
                      <img
                        :src="'/images/lenders/' + key + '.png'"
                        width="10"
                      />
                    </td>
                    <td>{{ index }}</td>
                    <td>{{ ko | list }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-else>
          <md-empty-state
            md-icon="close"
            md-label="No Assessment selected"
            md-description="Please select an assessment to show detail."
          />
        </div>
      </md-dialog-content>
    </group-card>
  </div>
</template>
<script>
import GroupCard from "../components/Cards/GroupCard";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import PropertyView from "../components/ApplicationSummary/PropertyView";
import GroupCardRow from "../components/Cards/GroupCardRow";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import AlertDialog from "../components/Dialogs/AlertDialog";
import ValidatedNumberInput from "../components/ValidatedInput/ValidatedNumberInput";

export default {
  components: {
    ValidatedNumberInput,
    LoadingIconTextButton,
    PropertyView,
    GroupCard,
    GroupCardRow,
  },
  data() {
    return {
      application_id: null,
      applicationData: null,
      loading: false,
      assessmentOutcomes: [],
    };
  },
  props: {
    targetId: {
      type: String,
      default: null,
    }
  },
  watch: {
    targetId: function(newVal, oldVal) {
      if (newVal) {
        this.application_id = newVal;
        this.getAssessmentOutcomesList();
      }
    }
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    async getAssessmentOutcomesList() {
      // initial data
      this.applicationData = null;
      this.assessmentOutcomes = [];
      if (!this.application_id) {
        this.showNotification("Application ID is required", "Error!");
        return;
      }
      //if application id is not number show error
      if (isNaN(this.application_id)) {
        this.showNotification("Application ID must be numbers.", "Error!");
        return;
      }
      try {
        this.loading = true;
        let response = await axios.get(
          `/api/v1/administration/getAdpBreakdown/${this.application_id}`
        );
        if (!response.data.status) {
          this.showNotification(response.data.message, "Error!");
          return;
        }
        this.assessmentOutcomes = response.data.data;
        if (this.assessmentOutcomes.ba_breakdown.length > 0) {
          this.assessmentOutcomes.ba_breakdown.forEach(
            (element) => (element.isSelected = false)
          );
        }
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.showNotification(e, "Error!");
      }
    },
    showNotification(message, title) {
      if (this.$modal.submit) {
        this.$modal.submit();
      }
      this.$modal.show(AlertDialog, {
        title: title,
        message: message,
      });
      this.loading = false;
    },
    getAdpBreakdownDetail(e, item) {
      if (item.isSelected) {
        this.applicationData = null;
        item.isSelected = false;
      } else {
        // set isSelected to current applicationData
        if (this.applicationData) {
          this.applicationData.isSelected = false;
        }
        item.isSelected = true;
        this.applicationData = item;
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
};
</script>
<style scoped>
.md-card img {
  width: 20% !important;
}
.product-breakdown {
  margin-bottom: 10px !important;
}
.product-breakdown tr,
.product-breakdown th {
  width: 20px !important;
}
.show-list-button {
  margin-top: 20px;
}
</style>
